import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'PinPinned',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "9.7", y1: "18.86", x2: "8.45", y2: "21.03" }
      }), h("path", {
        attrs: { d: "M16.4 21.04c.04-1.01-.09-2.32-.8-3.39l3.5-6.06s1.17.17 2.22-.52c.62-.4.58-1.33-.06-1.7l-9.11-5.26c-.64-.37-1.46.06-1.5.8-.07 1.25.66 2.18.66 2.18l-3.5 6.06c-1.29-.08-2.49.47-3.34 1-.64.4-.61 1.33.04 1.71l10.4 6c.64.38 1.46-.07 1.49-.82zm-2.28-4.82c-.14.24-.44.32-.68.18a.493.493 0 0 1-.18-.68l3-5.2c.14-.24.44-.32.68-.18.24.14.32.44.18.68l-3 5.2z" }
      })]
    );
  }
};